import "./Confirm.scoped.scss"
import { confirmCancelActionState, confirmCancelTextState, confirmConfirmActionState, confirmConfirmTextState, confirmMessageState } from "../../atoms/common";
import { getRecoil } from "recoil-nexus";

function Confirm() {
  const confirmConfirmAction = getRecoil(confirmConfirmActionState);
  const confirmCancelAction = getRecoil(confirmCancelActionState);
  const confirmConfirmText = getRecoil(confirmConfirmTextState);
  const confirmCancelText = getRecoil(confirmCancelTextState);
  const confirmMessage = getRecoil(confirmMessageState);

  return (
    <div className="confirm-warpper">
      <div className="confirm">
        <div className="confirm__header">
          <div>확인</div>
        </div>
        <div className="confirm__contents">
          <div className="confirm__row" dangerouslySetInnerHTML={{ __html: confirmMessage.split('\n').join('<br/>')}}>
          </div>
          <div className="confirm__button">
            <button onClick={confirmCancelAction}>{confirmCancelText}</button>
            <button className="confirm-button" onClick={confirmConfirmAction}>{confirmConfirmText}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirm;